import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { setPath, siteboardAction } from '../actions/defaultActions';
import { SET_LAST_VIEWED_PROJECT } from '../actions/types';

import PoweredByBar from './PoweredByBar';

// icon imports
import PrintIcon from '../icons/printIcon';
import EmailIcon from '../icons/emailIcon';
import MessagesIcon from '../icons/messagesIcon';
import EditIcon from '../icons/editIcon';
import Messages2Icon from '../icons/messages2Icon';
import TrashIcon from '../icons/trashIcon';
import GantChartIcon from '../icons/gantChartIcon';
import DashboardIcon from '../icons/dashboardIcon';
import NotepadIcon from '../icons/notepadIcon';

const Project = ({ _projects, setPath, siteboardAction, projectId }) => {
  const selectedProject = projectId in _projects ? _projects[projectId] : {};

  useEffect(() => {
    siteboardAction(SET_LAST_VIEWED_PROJECT, {projectId: projectId});
  }, [siteboardAction, projectId]);

  return (
    <div className={'flex flex-col w-full h-full overflow-y-auto'}>
      <div className={'flex flex-col gap-y-1.5 flex-col-reverse sm:flex-row justify-between items-center gap-x-[9px] p-1 bg-black'}>
        {/* Project name/job number/address */}
        <div className='flex flex-col w-full'>
          <div>
            <p className='inline text-[2em] text-[#f9a928] font-bold leading-[1em]'>{selectedProject.name}</p>
            {(typeof selectedProject.jobNumber === 'string' && selectedProject.jobNumber.length > 0) &&
              <p className='inline text-[1em] text-[#f9a928] leading-[1em]'> Job #{selectedProject.jobNumber}</p>
            }
          </div>
          <div>
            <p className='text-[1em] text-[#a59e9e] whitespace-nowrap'>{(selectedProject.address || '').replaceAll(/\n/g, ', ')}</p>
          </div>
        </div>
        <div className='hidden xl:flex justify-between w-full'>
          <div className='flex items-center gap-x-[8px]'>
            <div className=''><DashboardIcon size='28' color='#1267e7' /></div>
            <p className='text-[1.4em] font-bold text-[#a59e9e]'>Project Dashboard</p>
          </div>
          <div className='flex gap-x-[35px] items-center'>
          </div>
        </div>
      </div>
      <div className={'grow flex min-h-0'}>
        <div className='flex flex-col grow'>
          {/* main area */}
          <div className='grow flex flex-col justify-center items-center bg-[#333]'>
            <div className='flex flex-col w-full gap-y-[40px]'>
              <div className='font-bold text-[2.5em] text-white text-center'>Work Spaces</div>
              <div className='flex justify-around'>
                {/* 3 week button */}
                <button 
                  className='flex flex-col group items-center gap-y-[5px]'
                  onClick={() => { setPath('projectId#' + selectedProject.id + '#schedule'); }}
                >
                  <div className='flex group-hover:hidden justify-center items-center w-[120px] h-[120px] bg-[#444247] border border-[#a59e9e] rounded-[5px]'>
                    <GantChartIcon size='92' />
                  </div>
                  <div className='hidden group-hover:flex justify-center items-center w-[120px] h-[120px] bg-[#444247] border border-[#a59e9e] rounded-[5px]'>
                    <GantChartIcon size='92' color='#471cff' />
                  </div>
                  <p className='flex font-bold text-[2em] text-[#a59e9e] group-hover:text-[#ddd]'>3-Weeks</p>
                </button>
                {/* daily reports button */}
                {process.env.REACT_APP_DAILY_REPORTS_ENABLE === 'true' &&
                  <button 
                    className='flex flex-col group items-center gap-y-[5px]'
                    onClick={() => { setPath('projectId#' + selectedProject.id + '#dailyReports'); }}
                  >
                    <div className='flex group-hover:hidden justify-center items-center w-[120px] h-[120px] bg-[#444247] border border-[#a59e9e] rounded-[5px]'>
                      <NotepadIcon size='92' color='#a59e9e' />
                    </div>
                    <div className='hidden group-hover:flex justify-center items-center w-[120px] h-[120px] bg-[#444247] border border-[#a59e9e] rounded-[5px]'>
                      <NotepadIcon size='92' color='#55fa79' />
                    </div>
                    <p className='flex font-bold text-[2em] text-[#a59e9e] group-hover:text-[#ddd]'>Daily Reports</p>
                  </button>
                }
              </div>
            </div>
          </div>
          <PoweredByBar />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => { return { // define redux state that will be passed in as props
  _projects: state.serverSynced.projects,
}};
export default connect(mapStateToProps, {setPath, siteboardAction})(Project);
